export default "__VITE_ASSET__Bt3vqG3X__"